import React, { Component } from 'react'
import './GeomConvert.scss';
import { Input, Button,Checkbox, message } from 'antd';
import { ArrowRightOutlined, ArrowLeftOutlined,CopyOutlined,DownloadOutlined,SendOutlined } from '@ant-design/icons';
import { geometryUtil } from './../../util/geometryUtil'
import context from '../../context';
import MapWidgetUI from '../../components/MapWidgetUI';
const { TextArea } = Input;
const { Search } = Input;

const compareConfig = [
  {label:"对比one",key:"firstHub",color:"#a31314"},
  {label:"对比two",key:"secondHub",color:"#f56607"},
  {label:"对比three",key:"thirdHub",color:"#027912"},
  {label:"对比four",key:"fourthHub",color:"#f7f706"},
  {label:"对比five",key:"fifthHub",color:"#159ff0"},
  {label:"对比six",key:"sixthHub",color:"#820ce4"},
];
export default class GeomDiff extends Component {
  map = null;
  constructor(props) {
    super(props)
    this.state = {
      hubObj: {},
    }
  }
  _onChange = (type,e) => {
    this.setState((prevState=>({
      hubObj:{
        ...prevState.hubObj,
        [type]: e.target.value,
      }
    })));
    let style = {"size": "2","color": "#e30909","fillColor": "rgba(252,219,87,0.4)"};
    const coods = geometryUtil.anyToToGeometry(e.target.value);
    this.props.onAddLayer(coods,style);
  }
  render() {
    const { hubObj } = this.state;
    return <div className="geom-comparison" style={{display: 'flex',justifyContent: 'space-between'}}>
      {compareConfig.map(item=>{
        return <div key={item.key} style={{width:"16.3%"}}>
          <span style={{color:item.color}}>{item.label}</span>
          <TextArea value={hubObj[item.key]||""} style={{color:item.color}} rows={8} onChange={(e) => this._onChange(item.key,e)} />
        </div>
      })}
    </div>
  }
}